import { render } from "./SaleModalSectionDetails.vue?vue&type=template&id=b69aa39a"
import script from "./SaleModalSectionDetails.vue?vue&type=script&lang=js"
export * from "./SaleModalSectionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__